module.exports = __webpack_public_path__ + "static/media/Entry.40439394.svg";